import {Icon} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {Button} from '../../Button/Button';
import {SEPARATOR} from '../constants/separator';

interface PaginationPageProps extends TestIdProps {
  page: number;
  activePage: number;
  changePage: (newPage: number) => void;
  isDisabled?: boolean;
  isFocused?: boolean;
}

const pageSeparatorVariants = cva('p-1 [&_svg]:w-4');

export function PaginationPage(props: PaginationPageProps) {
  const isActive = props.activePage === props.page;
  const isNeedSeparator = props.page === SEPARATOR;

  if (isNeedSeparator) {
    return (
      <div
        className={cn(pageSeparatorVariants())}
        data-testid={suffixTestId('paginationPageWrapper', props)}
      >
        <Icon value="navigation/more_horiz" />
      </div>
    );
  }

  return (
    <Button
      key={`button_${props.page}`}
      onClick={!props.isDisabled ? () => props.changePage(props.page) : undefined}
      isDisabled={props.isDisabled}
      isFocused={props.isFocused}
      variant={isActive ? 'primary' : 'ghost'}
      size="small"
      tabIndex={-1}
      data-testid={suffixTestId('paginationPageButton', props)}
      title={String(props.page)}
    />
  );
}
